/**
 * 人物排行榜
 * 2017-11-21
 * Bai.Zhiming
 */
"use strict";
angular.module("charactersListModule", []).
controller("charactersListCtrl", ["$scope", "$q", "trsHttpService",'$state',function($scope, $q, trsHttpService,$state) {
    initStatus();
    initData();
    /*
     *changeFigureTab[ description] 人物排行榜Tab按钮
     *@params channel   [description]标题名称
     */
    $scope.changeFigureTab = function(channel) {
        //初始化人物榜单分页为 1
        $scope.pages.CURRPAGE = 1;
        //初始化人物榜单跳转页为 1
        $scope.status.jumpToPagesNum = 1;
        figureRankingdetail(channel);
    };
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            //初始化人物榜单TAB
            figureListTab: [],
            figureListDetail: [],
            jumpToPagesNum: 1, //人物榜单跳转页
            //初始化大图长宽
            initBigRankingwidth: {
                height: '240px',
                width: '1000px'
            },

        };
        $scope.data = {};
        //人物榜单页页
        $scope.pages = {
            "CURRPAGE": 1,
            "PAGESIZE": 10,
            "ITEMCOUNT": 0,
            "PAGECOUNT": 0,
        };
    }
    /*
     *[  readCurve 人物榜单切换数据]
     *@params channel   [description]标题名称
     */
    function figureRankingdetail(channel) {
        //除 推荐 外,其他切换不显示分页
        $scope.status.showPeopleListPages = channel;
        if(!channel) return; //容错
        if (channel === '推荐') {
            // 标题为推荐时,用推荐数据请求方法
            figureRankingRecommendDetail().then(function(data) {
                $scope.data.figureListDetail = data.PAGEITEMS;
            });
            return;
        }
        var ranking = {
            typeid: "widget",
            serviceid: "figurerank",
            modelid: "content",
            channel: channel
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), ranking, "get").then(function(data) {
            $scope.data.figureListDetail = data;
        });
    }
    /*
     *[  readCurve description] 人物榜单推荐数据
     *@params channel   [description]标题名称
     */
    function figureRankingRecommendDetail() {
        var defer = $q.defer();
        var ranking = {
            typeid: "widget",
            serviceid: "figurerank",
            modelid: "recommendation",
            //请求当前页起始页为0,大数据默认为0
            page_no: $scope.pages.CURRPAGE - 1,
            page_size: $scope.pages.PAGESIZE
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), ranking, "get").then(function(data) {
            $scope.data.figureRecommendList = data.PAGEITEMS;
            $scope.pages.ITEMCOUNT = data.TOTALITEMCOUNT;
            $scope.pages.PAGECOUNT = data.TOTALPAGECOUNT;
            defer.resolve(data);
        });
        return defer.promise;
    }
    /*
     *[  readCurve description] 人物榜单标题
     *
     */
    function figureRankingList(recommendList) {
        var ranking = {
            typeid: "widget",
            serviceid: "figurerank",
            modelid: "channel",
        };
        trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), ranking, "get").then(function(data) {
            $scope.data.figureListTab = typeof data === 'string' ? data = [] : data;
            if (angular.isArray(recommendList.PAGEITEMS) && recommendList.PAGEITEMS.length > 0 && recommendList.PAGEITEMS[0] != null) {
                $scope.data.figureListTab.unshift('推荐');
            }
            figureRankingdetail(data[0]);
        });
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        //初始化门户排行榜
        figureRankingRecommendDetail().then(function(data) {
            figureRankingList(data);
        });
    }
    /**
     * [pageChangeds 人物榜单 推荐页 上下翻页]
     * @return {[type]} [description]
     */
    $scope.pageChangeds = function() {
        // figureRankingRecommendDetail 函数取的是推荐页数据,赋值到页面上取数组为$scope.data.figureListDetail
        figureRankingRecommendDetail().then(function(data) {
            $scope.data.figureListDetail = data.PAGEITEMS;
        });
        $scope.status.jumpToPagesNum = $scope.pages.CURRPAGE;
    };
    /**
     * [jumpToPages 人物榜单 推荐页 跳转页]
     * @return {[type]} [description]
     */
    $scope.jumpToPages = function() {
        if ($scope.status.jumpToPagesNum > $scope.pages.PAGECOUNT) {
            $scope.status.jumpToPagesNum = $scope.pages.PAGECOUNT;
        }
        $scope.pages.CURRPAGE = $scope.status.jumpToPagesNum;
        // figureRankingRecommendDetail 函数取的是推荐页数据,赋值到页面上取数组为$scope.data.figureListDetail
        figureRankingRecommendDetail().then(function(data) {
            $scope.data.figureListDetail = data.PAGEITEMS;
        });
    };
    /**
     * [searchData description] 请求数据跳转高级搜索结果页
     * @return {[type]} [description]
     */
    $scope.searchData=function(val) {
        var url = $state.href('seniorResults');
        var params={
            num:1,
            val:val
        };
        window.open(url + "?rightsData=" + JSON.stringify(params));
    };
}]);